import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../__utils/spacingClassNamePropType';

const Link = ({ children, type, href, target, download, displayType, qaId, className }) => {
  const linkClasses = classNames({
    [`uni-link--${type}`]: type,
    [`uni-link--is-${displayType}`]: displayType,
    [className]: className,
  });

  const rel = target ? 'noopener noreferrer' : null;

  return (
    <a className={linkClasses} href={href} target={target} rel={rel} download={download} data-qa-id={qaId}>
      {children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['default', 'article', 'implied', 'wrapper', 'button']),
  href: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  download: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  displayType: PropTypes.oneOf(['block', 'inline-block']),
  qaId: PropTypes.string,
  className: spacingClassNamePropType,
};

Link.defaultProps = {
  type: 'default',
  className: '',
};

export default Link;



// WEBPACK FOOTER //
// ./src/link/index.jsx